import { createFileRoute, redirect } from "@tanstack/react-router";
import { bookmarkListInfiniteQueryOptions } from "~/features/favorites/api";
import { CocoplusFavoritesTemplate } from "~/features/favorites/CocoplusFavoritesTemplate";
import { isCocoplusApp } from "~/lib/applicationId";

// coco+ の下部ナビ「お気に入り」（推しの近況）
export const Route = createFileRoute("/_authenticated/favorites/")({
  // 下部ナビに出しているのは coco+ だけ。他アプリで直接開かれたらさがすへ戻す
  beforeLoad: () => {
    if (!isCocoplusApp()) throw redirect({ to: "/discover" });
  },
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(bookmarkListInfiniteQueryOptions),
  component: CocoplusFavoritesTemplate,
});
